<template>
  <div class="version" data-test-id="VersionComponent">v{{ version }}</div>
</template>

<script>
import Vue from "vue";

import { version } from "../../../package.json";

export default Vue.extend({
  name: "Version",

  data() {
    return {
      version
    };
  }
});
</script>

<style>
.version {
  border: 1px solid #dddddd;
  border-radius: 5px;
  bottom: 10px;
  color: #333333;
  font-size: 0.8rem;
  padding: 0 4px;
  position: fixed;
  right: 10px;
}
</style>
